module.exports = __webpack_public_path__ + "img/sychev.9648f60a.jpg";